// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3201":"css/app.6801","4662":"css/admin-app.6801"}[chunkId] + ".css";
};